interface Props {
  pathname: string;
}

export function lockSvg(props: Props) {
  return (
<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.89478" width="11.3684" height="13.2632" rx="4" fill="#1F7DFF"/>
<rect x="3.59998" y="1.43994" width="7.92" height="11.52" rx="2" fill="#15171A"/>
<rect y="7.19995" width="15.12" height="10.8" rx="2" fill="#1F7DFF"/>
<rect x="1.43994" y="8.64001" width="12.24" height="7.92" rx="2" fill="#15171A"/>
<rect x="6.47998" y="10.8" width="2.16" height="4.32" rx="1" fill="#1F7DFF"/>
<circle cx="7.56001" cy="11.16" r="1.8" fill="#1F7DFF"/>
</svg>)
}
